export const VIEW_AS_DURATION_MS = 30 * 60 * 1000;

export const VIEW_AS_REASON_MAX_LENGTH = 500;

export const VIEW_AS_PURPOSE = { DEMO: "demo" } as const;

export const DEMO_SESSION_DURATION_MS = 8 * 60 * 60 * 1000;

export const VIEW_AS_END_REASONS = ["exited", "expired"] as const;

export type ViewAsEndReason = (typeof VIEW_AS_END_REASONS)[number];

export const VIEW_AS_AUDIT_ACTIONS = {
  started: "view_as_started",
  ended: "view_as_ended",
  demoStarted: "demo_started",
  demoReset: "demo_reset",
} as const;

export const VIEW_AS_READ_ONLY_MESSAGE =
  "You are viewing as another user, which is read-only. Exit view-as to make changes.";
